'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListTypeDropdown = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseDropdown = require('@bibliocommons/base-dropdown');

require('../styles/ListTypeDropdown.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListTypeDropdown = exports.ListTypeDropdown = function (_BcReactComponent) {
  _inherits(ListTypeDropdown, _BcReactComponent);

  function ListTypeDropdown(props) {
    _classCallCheck(this, ListTypeDropdown);

    var _this = _possibleConstructorReturn(this, (ListTypeDropdown.__proto__ || Object.getPrototypeOf(ListTypeDropdown)).call(this, props));

    _this.bindAll('handleSelect');
    return _this;
  }

  _createClass(ListTypeDropdown, [{
    key: 'getLabelForListType',
    value: function getLabelForListType(listType) {
      return this.props.intl.formatMessage({
        id: 'user_list_purpose_' + listType
      });
    }
  }, {
    key: 'getOptionsForDropdown',
    value: function getOptionsForDropdown() {
      var _this2 = this;

      return this.props.listTypes.map(function (listType) {
        return {
          label: _this2.getLabelForListType(listType),
          value: listType
        };
      }).toIndexedSeq().toJS();
    }
  }, {
    key: 'handleSelect',
    value: function handleSelect(listType) {
      this.props.handleListPropertyChange(_immutable2.default.Map({ listType: listType }));
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var options = this.getOptionsForDropdown();

      return _react2.default.createElement(
        'div',
        { className: 'cp-list-type-dropdown' },
        _react2.default.createElement(
          'label',
          { id: 'list-type-dropdown-label', htmlFor: 'list-type-dropdown' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_type_dropdown_label' })
        ),
        _react2.default.createElement(_baseDropdown.Dropdown, {
          selected: this.getLabelForListType(this.props.currentListType),
          dropdownMenuId: 'list-type-dropdown',
          labelledById: 'list-type-dropdown-label',
          options: options,
          className: 'btn-block',
          handleSelect: this.handleSelect,
          testId: 'list-type-dropdown' })
      );
    }
  }]);

  return ListTypeDropdown;
}(_baseBcReactComponent2.default);

ListTypeDropdown.propTypes = {
  handleListPropertyChange: _react.PropTypes.func.isRequired,
  listTypes: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
  currentListType: _react.PropTypes.string.isRequired,

  intl: _reactIntl.intlShape
};

exports.default = (0, _reactIntl.injectIntl)(ListTypeDropdown);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/list-type-dropdown/components/ListTypeDropdown.component.js
// module id = 1315
// module chunks = 0